module.exports = __webpack_public_path__ + "static/media/it2.bb6f72d2.jpg";